import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Table, Params, Actions, Menu } from 'nallian-table-builder-ui';
import { Link, Button } from 'nallian-shared-ui/lib/components';
import { MEMBERS_ACTIONS } from '../helpers/communityMembersNavHelper';
import NewCommunityMember from './NewCommunityMember';
import ViewCommunityMemberModal from './ViewCommunityMemberModal';
import apiRoutes from '../../../../app/api/routes';
import CommunityMemberStateFilter from './table/StateFilter';
import ApplyOnboardingTemplate from '../../../../mgmt/communities/components/communityMembers/ApplyOnboardingTemplate';

const infiniteScroll = { loader: 'blocked' };

const CommunityMembersOverview = ({ communityId, isCommunityView }) => {
  const { t } = useTranslation();
  const { action, actionId } = useParams();

  return (
    <>
      <Link to={`/community/members/${MEMBERS_ACTIONS.NEW_MEMBER}`}>
        <Button btnprimary icon="plus" content={t('createCommunityMember')} />
      </Link>
      <NewCommunityMember
        isCommunityView={isCommunityView}
        returnUrl="/community/members"
        communityId={communityId}
        open={!!action && action === MEMBERS_ACTIONS.NEW_MEMBER}
      />
      {action === MEMBERS_ACTIONS.VIEW_MEMBER && actionId && communityId && (
        <ViewCommunityMemberModal open organisationId={actionId} communityId={communityId} />
      )}
      {action === MEMBERS_ACTIONS.APPLY_ONBOARDING_TEMPLATE && actionId && communityId && (
        <ApplyOnboardingTemplate open communityId={communityId} returnRoute="/community/members" />
      )}
      <Table
        resource="communityMembers"
        idProp="organisation.id"
        url={apiRoutes.getCommunityMembers(communityId)}
        infiniteScroll={infiniteScroll}
        pageSize={50}
        filtered
        noUserSettings
      >
        <Actions.Link
          iconbutton
          width="3rem"
          icon="eye"
          align="center"
          url={`/community/members/${MEMBERS_ACTIONS.VIEW_MEMBER}/:organisation.id`}
        />
        <Params.String
          label="organisationName"
          filterName="organisationName"
          name="organisation.name"
          width="5rem"
          grow
        />
        <Params.String
          label="state"
          name="state.name"
          width="5rem"
          filter={CommunityMemberStateFilter}
          grow
        />
        <Params.DateTime name="createdOn" width="5rem" grow noFilter />
        <Menu width="3.5rem" align="center">
          <Actions.Link
            label="applyOnboardingTemplate"
            icon="copy"
            url={`/community/members/${MEMBERS_ACTIONS.APPLY_ONBOARDING_TEMPLATE}/:organisation.id`}
          />
        </Menu>
      </Table>
    </>
  );
};

CommunityMembersOverview.propTypes = {
  communityId: PropTypes.string.isRequired,
  isCommunityView: PropTypes.bool,
};

CommunityMembersOverview.defaultProps = { isCommunityView: false };

export default CommunityMembersOverview;
